// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"RolesAsignar_spinnerContainer__X5SZP","botonAdd":"RolesAsignar_botonAdd__IRJWL"};